/**
 * Page-content API brand normalization (shared with auth labels, home content, suite avail, etc.).
 * Uses {@link Brand} as the single source of truth for valid short names.
 */
import { Brand } from '@typescript'
import { createLogger } from '@utils/Logger'

const logger = createLogger('PageContentBrand')

export function isEbacThemeBrand(themeBrand: string): boolean {
  return themeBrandToPageContentBrand(themeBrand) === 'ebac'
}

/**
 * Map frontend theme/site brand (cw, wm, sir, ev/ebac) to a backend-accepted Brand identifier
 * for the page-content API.
 *
 * IMPORTANT: mkback's `Brand.from()` does NOT accept enum names like "SPORTSILLUSTRATED";
 * it accepts shortName, number, or displayNames (e.g. "sir", "si", "005", "ebac").
 *
 * Unknown values fall back to `"sir"`.
 */
export function themeBrandToPageContentBrand(themeBrand: string): string {
  const lower = (themeBrand || '').toLowerCase().trim()
  if (!lower) return 'sir'
  // mkdev may set themeBrand to "ev" (Everest). Backend expects "ebac" for EVEREST.
  if (lower === 'ev') return 'ebac'
  try {
    Brand.fromShortName(lower)
    return lower
  } catch {
    if (process.env.NODE_ENV === 'development') {
      logger.warn(`Unknown themeBrand "${themeBrand}", falling back to "sir"`)
    }
    return 'sir'
  }
}
